module.exports = __webpack_public_path__ + "img/lightbulb.8a850e77.png";